import { Node } from 'tiptap'
import { toggleWrap } from 'tiptap-commands'

const youtubeLink = (url) => {
  var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  var match = url.match(regExp);
  if (match && match[2].length == 11) {
    return match[2];
  } else {
    //error
    return ""
  }
}
export default class TiptapYoutube extends Node {
  get name() {
    return 'youtube'
  }
  commands({ type, schema }) {
    
    return attrs => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
  get schema() {
    return {
      inline: true,
      attrs: {
        src: {}
      },
      group: 'inline',
      selectable: false,
      parseDOM: [{
        tag: 'iframe[src]',
        getAttrs: dom => ({
          src: dom.getAttribute('src'),
        }),
      }],
      toDOM: node => ['iframe', {
        src: node.attrs.src,
        frameborder: 0,
        allowfullscreen: 'true',
      }],
    }
  }
  get view() {
    return {
      // there are some props available
      // `node` is a Prosemirror Node Object
      // `updateAttrs` is a function to update attributes defined in `schema`
      // `view` is the ProseMirror view instance
      // `options` is an array of your extension options
      // `selected` is a boolean which is true when selected
      // `editor` is a reference to the TipTap editor instance
      // `getPos` is a function to retrieve the start position of the node
      // `decorations` is an array of decorations around the node
      props: ['node', 'updateAttrs', 'view'],
      computed: {
        src: {
          get() {
            const id = youtubeLink(this.node.attrs.src);
            return `https://youtube.com/embed/${id}`
          },
          set(src) {
            // we cannot update `src` itself because `this.node.attrs` is immutable
            const id = youtubeLink(src);
            const embedSrc = `https://youtube.com/embed/${id}`
            this.updateAttrs({
              src: embedSrc,
            })
          },
        },
      },
      template: `
        <div class="iframe">
          <iframe :src="src" frameborder="0" allowfullscreen></iframe>
        </div>
      `,
    }
  }
}